export default {
  getActive: (state) => {
    return state.active;
  },
  getLastHeight: (state) => {
    return state.last_table_height;
  },
  getCategory: (state) => {
    return state.category;
  },
  getModel: (state) => {
    return state.model;
  },
  getSelCat: (state) => {
    return state.selected_catalog;
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js